import { action, makeAutoObservable, observable } from "mobx"

import importService from "@services/common/importService"
import { ModuleEnum } from "@lib/enum"
import {
  ExportConfigModel,
  ImportColumnModel,
} from "@models/common/importColumnModel"

class ImportStore {
  @observable isLoading!: boolean
  @observable listValidation!: ImportColumnModel[]
  @observable listExportConfiguration!: ExportConfigModel[]
  constructor() {
    makeAutoObservable(this)
    this.isLoading = false
    this.listValidation = []
  }
  @action
  async getExportConfiguration(module: ModuleEnum) {
    this.isLoading = true
    const result = await importService
      .getExportConfiguration(module)
      .finally(() => (this.isLoading = false))
    this.listExportConfiguration = result
    return result
  }

  @action
  async getModelValidation(module: ModuleEnum) {
    this.isLoading = true
    const result = await importService
      .getModelValidation(module)
      .finally(() => (this.isLoading = false))
    this.listValidation = result
    return result
  }

  @action
  async getTemplate(params: any) {
    this.isLoading = true
    await importService
      .getTemplate(params)
      .finally(() => (this.isLoading = false))
  }

  // Export by module
  @action
  async exportUnit(params: any, payload: any) {
    this.isLoading = true
    await importService
      .exportUnit(params, payload)
      .finally(() => (this.isLoading = false))
  }
  @action
  async exportCustomer(params: any, payload: any) {
    this.isLoading = true
    await importService
      .exportCustomer(params, payload)
      .finally(() => (this.isLoading = false))
  }

  @action
  async exportBooking(params: any, payload: any) {
    this.isLoading = true
    await importService
      .exportBooking(params, payload)
      .finally(() => (this.isLoading = false))
  }

  @action
  async exportUnitPricingApproval(params: any) {
    this.isLoading = true
    await importService
      .exportUnitPricingApproval(params)
      .finally(() => (this.isLoading = false))
  }
  @action
  public validatePricingApprovalBeforeImport = async (file: File) => {
    this.isLoading = true
    try {
      const result = await importService
        .validatePricingApprovalBeforeImport(file)
        .finally(() => (this.isLoading = false))

      return result
    } catch (error) {
      this.isLoading = false
      throw error
    }
  }
  @action
  async exportHandoverReservation(params: any) {
    this.isLoading = true
    await importService
      .exportHandoverReservation(params)
      .finally(() => (this.isLoading = false))
  }
  async exportFeedback(params: any, payload: any) {
    this.isLoading = true
    await importService
      .exportFeedback(params, payload)
      .finally(() => (this.isLoading = false))
  }

  @action
  async exportInquiry(params: any, payload: any) {
    this.isLoading = true
  }

  @action 
  async exportSaleEventBooking(params: any) {
    this.isLoading = true
    await importService
      .exportSaleEventBooking(params)
      .finally(() => (this.isLoading = false))
  }

  @action
  async exportSaleEventBookingDailySales(params: any) {
    this.isLoading = true
    await importService
      .exportSaleEventBookingDailySales(params)
      .finally(() => (this.isLoading = false))
  }

  @action
  async exportSaleEventBookingOffline(params: any) {
    this.isLoading = true
    await importService
      .exportSaleEventBookingOffline(params)
      .finally(() => (this.isLoading = false))
  }

  @action
  async exportSaleEventBookingOnline(params: any) {
    await importService
      .exportSaleEventBookingOnline(params)
      .finally()
  }

  @action
  async ValidateBeforeImportBookingToContract(file: File) {
    this.isLoading = true
    const result = await importService
      .ValidateBeforeImportBookingToContract(file)
      .finally(() => (this.isLoading = false))
    return result
  }
}

export default ImportStore
